export const classicPlanTemplates = {
  monthly: [
    {
      key: "monthly_basic",
      envKey: "REACT_APP_MONTHLY_PLAN_1",
      name: "Monthly Basic",
      tierLabel: "Basic",
      price: "19",
      groupLimit: 2,
    },
    {
      key: "monthly_pro",
      envKey: "REACT_APP_MONTHLY_PLAN_2",
      name: "Monthly Pro",
      tierLabel: "Pro",
      price: "29",
      groupLimit: 4,
      badge: "Most Popular",
    },
    {
      key: "monthly_mega",
      envKey: "REACT_APP_MONTHLY_PLAN_3",
      name: "Monthly Mega",
      tierLabel: "Mega",
      price: "49",
      groupLimit: 20,
    },
  ],
  yearly: [
    {
      key: "yearly_basic",
      envKey: "REACT_APP_YEARLY_PLAN_1",
      name: "Yearly Basic",
      tierLabel: "Basic",
      price: "79",
      groupLimit: 2,
    },
    {
      key: "yearly_pro",
      envKey: "REACT_APP_YEARLY_PLAN_2",
      name: "Yearly Pro",
      tierLabel: "Pro",
      price: "99",
      groupLimit: 4,
      badge: "Most Popular",
    },
    {
      key: "yearly_mega",
      envKey: "REACT_APP_YEARLY_PLAN_3",
      name: "Yearly Mega",
      tierLabel: "Mega",
      price: "189",
      groupLimit: 20,
    },
  ],
};

export function getClassicPlanId(envKey) {
  const id = process.env[envKey];

  if (!id) {
    return null;
  }

  const numericId = parseInt(id, 10);
  return Number.isNaN(numericId) ? null : numericId;
}
